<template>
    <div class="container-fluid m-0 p-0">
        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
            <div class="col-sm-12 h-100 my-auto p-0 m-0">
                <span class="mx-3 font-weight-bold lead"> Crew Master List</span>
                <span class="mx-3">
                    <router-link
                            :to="{ name: 'CrewCreate' }"
                            tag="button"
                            class="btn btn-sm btn-outline-primary font-weight-bolder"
                            title="Add New Crew Record"
                            v-if="!guest"
                    >
                        <span class="fas fa-user-plus"></span>
                        Add Crew
                    </router-link>
                </span>

                <span class="float-right py-1 mx-2 pr-4">
                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled title="Print Crew Result">
                        <span class="fas fa-print"></span>
                        Print
                    </button>

                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled title="Print Crew Result">
                         <span class="fas fa-mail-bulk"></span>
                         Email
                    </button>

                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" disabled title="Print Crew Result">
                         <span class="fas fa-file-excel"></span>
                        Export
                    </button>

                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-5 offset-2">
                <form class="form-inline py-2 my-lg-0" @submit.prevent="setPage(1)">

                    <div class="input-group mx-auto">
                        <label for="searchField" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Search By:</label>
                        <div>
                            <select name="searchKey" id="searchKey" class="form-control form-control-xs left-rounded"
                                    @change="searchFieldFocus()"
                                    v-model="crewSearchParam.searchKey"
                            >
                                <option value="all">All</option>
                                <option value="ipn">Crew IPN</option>
                                <option value="first_name">First Name</option>
                                <option value="last_name">Last Name</option>
                            </select>
                        </div>

                        <input type="text" id="searchField"
                               class="form-control form-control-xs" style="width: 400px;"
                               aria-label="Recipient's username"
                               aria-describedby="basic-addon2"
                               :placeholder="keyPlaceHolder"
                               v-model="crewSearchParam.searchValue"
                        >
                        <div class="input-group-append">
                            <button type="submit" class="input-group-text input-group-append">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
            <div class="col col-sm-4">
                <div class="form-inline py-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="activity-code" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Activity Status:</label>
                        <select name="nationality" id="activity-code" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.activityCode"
                                @change="setPage()"
                        >
                            <option :value="0">--- ALL ACTIVITY STATUSES ---</option>
                            <option v-for="activityCodeKey in activityCodeKeys" :key="activityCodeKey.id" :value="activityCodeKey.id" :title="activityCodeKey.name">{{ activityCodeKey.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row text-small">
            <div class="col-sm-12 py-2 mb-2"><hr class="m-0"/></div>

            <div class="col col-sm-2" v-if="this.isPrincipal && manningKeys.length > 1">
                <div class="form-inline my-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="manning" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Manning:</label>
                        <select name="manning" id="manning" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.manning"
                                @change="setPage(1)">
                            <option :value="0">--- ALL ---</option>
                            <option v-for="manningKey in getManningLists"
                                    :key="manningKey.id"
                                    :value="manningKey.id"
                                    :title="manningKey.name"
                            >
                                {{ manningKey.alias }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col col-sm-2" :class="{'offset-2': !(this.isPrincipal && manningKeys.length > 1)}">
                <div class="form-inline my-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="searchField" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Rank:</label>
                        <select name="rank" id="rank" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.rank"
                                @change="setPage(1)"
                        >
                            <option :value="0">--- ALL RANKS ---</option>
                            <option v-for="rankKey in rankKeys"
                                    :key="rankKey.id"
                                    :value="rankKey.id"
                                    :title="rankKey.name"
                            >{{ rankKey.alias }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col col-sm-3" v-if="!this.isKline">
                <div class="form-inline my-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="searchField" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Nationality:</label>
                        <select name="nationality" id="nationality" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.natl"
                                @change="setPage(1)"
                        >
                            <option :value="0">--- ALL NATIONALITY ---</option>
                            <option v-for="natlKey in natlKeys" :key="natlKey.id" :value="natlKey.id" :title="natlKey.name">{{ natlKey.natl }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col col-sm-3" v-if="isSystemAdmin">
                <div class="form-inline my-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="searchField" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Pool:</label>
                        <select name="pool" id="pool" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.pooling"
                                @change="setPage(1)"
                        >
                            <option :value="0">--- ALL POOLING ---</option>
                            <option v-for="poolingKey in poolingKeys" :key="poolingKey.id" :value="poolingKey.id">
                                {{ poolingKey.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col col-sm-2">
                <div class="form-inline my-2 my-lg-0">
                    <div class="input-group mx-auto">
                        <label for="status" class="input-group-prepend input-group-text form-control-xs bg-white border-0 font-weight-bold">Account Status:</label>
                        <select id="status" class="form-control form-control-xs input-group-append"
                                v-model="crewSearchParam.crewStatus"
                                @change="setPage(1)"
                        >
                            <option :value="''">--- ALL ---</option>
                            <option :value="1">ACTIVE</option>
                            <option :value="0">INACTIVE</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="text-left">
                    <small v-if="pagination.from == null">{{ `No Records found` }}</small>
                    <small v-else>{{ `${pagination.from} to ${pagination.to} of ${pagination.total}` }}</small>
                </div>
            </div>
            <div class="col col-md-12">
                <table class="table table-hover table-bordered table-template-1 my-2 text-small">
                    <thead>
                    <tr>
                        <th style="width: 1%;">#</th>
                        <th style="width: 5%;">RANK</th>
                        <th>CREW IPN</th>
                        <th>FULL NAME</th>
                        <th style="width: 10%;">VESSEL/OFFICE</th>
                        <th style="width: 7%;">ACTIVITY STATUS</th>
                        <th style="width: 7%;">START DATE</th>
                        <th style="width: 7%;">END DATE</th>
                        <th style="width: 7%;">STATUS</th>
                        <th style="width: 7%;">NATIONALITY</th>
                        <th style="width: 10%;">POOL</th>
                        <th style="width: 10%;">MANNING</th>
                        <th class="col-actions" style="width: 10%;">ACTION</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(crew, index) in crews" :key="crew.id"
                        :class="{
                            inactive: !crew.active,
                            'text-danger': (crew.wrongDates && isSystemAdmin),
                            'bg-silver': (crew.g6m && isSystemAdmin),
                        }"
                    >
                        <td>{{ index + pagination.from }}</td>
                        <td :title="crew.rankName">{{ crew.rankAlias }}</td>
                        <td v-if="crew.ipn">{{ crew.ipn }}</td>
                        <td v-else>
                            <span class="bg-lightblue"
                                  title="TEMPORARY CREW CODE"
                            >{{ crew.code }}</span>
<!--                            <input type="text" :value="crew.code" readonly-->
<!--                                   placeholder="TEMPORARY CREW CODE"-->
<!--                                   class="form-control form-control-xs bg-lightblue"-->
<!--                            >-->
                        </td>
                        <td>{{ crew.fullName }}</td>
                        <td>
                            <span v-if="crew.vessel"> {{ crew.vessel }} </span>
                            <span v-else>
                                {{ crew.companyOfficeName }}
                                <template v-if="crew.companyOfficeName && crew.assignmentPositionName">/</template>
                                {{ crew.assignmentPositionName }}
                            </span>
                        </td>
                        <td :title="crew.activityCodeName"> {{ crew.activityCode }} </td>
                        <td :title="crew.signOnStatus">{{ crew.signOn }}</td>
                        <td :title="crew.signOffStatus">{{ crew.signOff }}</td>
                        <td>{{ crew.active |status }}</td>
                        <td>{{ crew.nationality }}</td>
                        <td :title="crew.poolingCode">{{ crew.poolingName }}</td>
                        <td :title="crew.manningName" >{{ crew.manningAlias }}</td>
                        <td class="text-center col-actions">
                            <button class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto" @click="viewCrew(crew.id)">
                                <span class="fas fa-eye"></span>
                                View
                            </button>

                            <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder ml-auto"
                                    v-if="isSystemAdmin"
                                    @click="confirmDeleteCrew(crew.id)"
                            >
                                <span class="fas fa-trash"></span>
                                Delete
                            </button>
                        </td>
                    </tr>
                    <tr v-if="crews.length === 0">
                      <td colspan="13">No Result Found</td>
                    </tr>
                    </tbody>
                </table>

                <nav aria-label="...">
                    <ul class="pagination text-smallest">
                        <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                            <button class="page-link" @click="setPage(1)">First</button>
                        </li>

                        <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                            <button class="page-link" @click="setPage(page)">{{ page }}</button>
                        </li>

                        <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

      <admin-announcement-modal></admin-announcement-modal>

    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import { vueAppMixin } from "@/mixins/vueAppMixin";
    import { dataMixin } from "@/mixins/dataMixin";
    import MasterListSideNavToggle from "../../../layouts/MasterListSideNavToggle";
    import { gateMixin } from "@/mixins/gateMixin";
    import { paginationMixin } from "@/mixins/paginationMixin";
    import $ from "jquery";
    import AdminAnnouncementModal from "@/components/sub_components/dashboards/AdminAnnouncementModal";

    export default {
        name: "CrewIndex",
        mixins: [ vueAppMixin, dataMixin, gateMixin, paginationMixin],

        components: {
            // MasterListSideNavToggle
          AdminAnnouncementModal
        },

        methods: {
            ...mapActions([
                'getManningKeys',
                'getRankKeys',
                'getNatlKeys',
                'getCrewList',
                'getPoolingKeys',
                'deleteCrew',
                'clearCrewList',
                'getActivityCodeKeys'
            ]),
            searchFieldFocus() {
                document.getElementById('searchField').focus();
            },

            searchCrew() {
                let page = this.pagination.currentPage;
                let params = {
                    page: page,
                    searchKey: this.crewSearchParam.searchKey,
                    searchValue: this.crewSearchParam.searchValue,
                    manning: this.crewSearchParam.manning,
                    rank: this.crewSearchParam.rank,
                    natl: this.crewSearchParam.natl,
                    pooling: this.crewSearchParam.pooling,
                    activityCode: this.crewSearchParam.activityCode
                };
                if(this.crewStatus !== '') {
                    params['crewStatus'] = this.crewSearchParam.crewStatus;
                }
                this.getCrewList(params);
            },

            setPage(page = null) {
                this.pagination.currentPage = page ?? 1;
                this.searchCrew();
            },

            viewCrew(crewId) {
                this.$router.push({ name: 'CrewActivity', params: { id: crewId }});
            },

          async confirmDeleteCrew(crewId) {
            if(await this.confirmDeleteAlert()) {
              if(await this.deleteCrew(crewId)) {
                this.successAlert('Crew Record Successfully Deleted', 'DELETE');
              }
            }
          },

          openModal () {
            let some = this.$route.params.announcementModalId;
            $(some).modal('show')
          },

        },

        computed: {
            ...mapGetters([
                'manningKeys',
                'rankKeys',
                'natlKeys',
                'poolingKeys',
                'crews',
                'manningId',
                'crewSearchParam',
                'poolingKeys',
                'activityCodeKeys'
            ]),
            keyPlaceHolder() {
                let placeholder = 'Type Anything Here';
                switch (this.crewSearchParam.searchKey) {
                    case 'All':
                        placeholder = 'Type Anything Here';
                        break;
                    case 'ipn':
                        placeholder = 'Type Crew IPN Here';
                        break;
                    case 'first_name':
                        placeholder = 'Type Crew First Name Here';
                        break;
                    case 'last_name':
                        placeholder = 'Type Crew Last Name Here';
                        break;
                }
                return placeholder;
            },
          getManningLists(){
            return this.manningKeys.filter((manning)=>{
              return this.isKline ? ![7,17].includes(manning.id) : true
            })
          }
        },

        created() {
            this.getActivityCodeKeys();
            this.getManningKeys();
            this.getRankKeys();
            this.getNatlKeys();
            if(this.user.manning_id) {
                this.manning = this.user.manning_id;
            } else {
                // this.manning = this.manningId;
                this.manning = 0;
            }
            this.searchValue = this.globalSearchValue;
            // this.searchCrew();
            this.getPoolingKeys();

          // this.updateCrewList = _.debounce(this.searchCrew, 500);

          this.updateCrewList = _.debounce(this.searchCrew, 500);

          // this.updateCrewList = _.debounce(this.searchCrew(), 500)
        },

        beforeDestroy() {
            this.clearCrewList();
        },

      watch: {
        'crewSearchParam.searchValue'() {
          this.updateCrewList();
        }
      },

      mounted() {
        this.openModal();
      }

    }
</script>

<style scoped>
    .left-rounded {
        border-radius: 0.25rem 0 0 0.25rem !important;
    }
    tbody tr td {
        text-align: center;
    }
    tbody tr td:nth-child(4) {
        text-align: left;
    }
</style>
